export default __webpack_public_path__ + "static/media/icon_personal_data.7f44d315.svg";